import { Box, Flex } from "@chakra-ui/react";
import { Z_INDEX } from "../../../constants/zIndex";
import { HeaderContextProvider } from "../../../hooks/useHeader";
import { Footer } from "./Footer";
import { Header } from "./Header";

/**
 * @typedef {Object} Props
 * @property {React.ReactNode} children
 *
 * @param {Props} props
 */
export function PublicLayout({ children }) {
  return (
    <HeaderContextProvider>
      <Flex flexDir="column" justifyContent="stretch" minH="100vh">
        <Box
          position="sticky"
          top="0"
          left="0"
          right="0"
          flexShrink={0}
          height={0}
          zIndex={Z_INDEX.HEADER_MENU}>
          <Header />
        </Box>

        <Flex flexDir="column" justifyContent="stretch" flexGrow={1}>
          {children}
        </Flex>

        <Box flexShrink={0}>
          <Footer />
        </Box>
      </Flex>
    </HeaderContextProvider>
  );
}
